import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, Switch } from 'ypf-pas-general-ui-components';

import { certificationServiceStatus } from '../../constants/constants';
import { Line } from '../../utils/globalPropTypes';
import AmountInput from '../WorkReports/AmountInput/AmountInput';

const EditAmount = (props) => {
  const {
    colors,
    line,
    onChange,
    onChangeExpertReview,
    unitMeasure,
    value,
    valueExpertReview,
    handleChangeOnColors,
    handleOnChangeQuantity,
    enableEdit,
    setEnableEdit
  } = props;

  const [firstValueColors, setFirstValueColors] = useState('');
  const [firstValueOfQuantity, setFirstValueOfQuantity] = useState();
  const [rectifyButtonLabel, setRectifyButtonLabel] = useState('Rectificar Cantidad');

  const handleClickRectifyQuantity = () => {
    if (!enableEdit) {
      // Si el boton esta deshabilitado
      handleChangeOnColors('#000000,#FFFFFF');
      setEnableEdit(true);
      setRectifyButtonLabel('Cancelar');
    } else {
      setEnableEdit(false);
      setRectifyButtonLabel('Rectificar Cantidad');
      handleChangeOnColors(firstValueColors);
      handleOnChangeQuantity(firstValueOfQuantity);
    }
  };

  useEffect(() => {
    if (line) {
      setFirstValueColors(line?.colores);
      setFirstValueOfQuantity(line?.cantidad);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [line]);

  return (
    <Row>
      <Col className="d-flex justify-content-between" sm={4}>
        <div className="d-flex align-items-center">
          <h6 className="mx-2 my-0">{unitMeasure}</h6>
          <div className="d-flex align-items-center">
            <AmountInput
              colors={colors}
              disabled={!line.estadoRevision.editar}
              forceEnabled={enableEdit}
              line={line}
              onChange={onChange}
              value={value}
            />
          </div>
          <div className="mx-4 my-0">
            <div className="d-flex justify-content-between">
              <Button
                className="button-link"
                disabled={!line.estadoRevision.editar}
                label={rectifyButtonLabel}
                onClick={handleClickRectifyQuantity}
                sizeIcon="27px"
                type="button"
                variant="outline-primary"
                widthButton="175px"
              />
            </div>
          </div>
        </div>
      </Col>

      {line?.estadoRevision.estadoCertEnum !== certificationServiceStatus.wrong ? (
        <Col className="d-flex justify-content-between" sm={8}>
          <div className="d-flex align-items-center">
            <h6 className="mx-2 my-0">Revisión experta</h6>
            <Switch
              checked={valueExpertReview}
              falseLabel="NO"
              name="expertReview"
              onChange={onChangeExpertReview}
              size="sm"
              trueLabel="SÍ"
            />
          </div>
        </Col>
      ) : null}
    </Row>
  );
};

EditAmount.propTypes = {
  colors: PropTypes.string,
  handleChangeOnColors: PropTypes.func,
  handleOnChangeQuantity: PropTypes.func,
  line: PropTypes.oneOfType([Line, PropTypes.number]),
  onChange: PropTypes.func,
  onChangeExpertReview: PropTypes.func,
  unitMeasure: PropTypes.string,
  value: PropTypes.number,
  valueExpertReview: PropTypes.bool,
  enableEdit: PropTypes.bool,
  setEnableEdit: PropTypes.func
};

EditAmount.defaultProps = {
  colors: '',
  handleChangeOnColors: () => {
    /* Empty */
  },
  handleOnChangeQuantity: () => {
    /* Empty */
  },
  line: {},
  onChange: () => {
    /* Empty */
  },
  onChangeExpertReview: () => {
    /* Empty */
  },
  unitMeasure: '',
  value: 0,
  valueExpertReview: false,
  enableEdit: false,
  setEnableEdit: () => {
    /* Empty */
  }
};

export default EditAmount;
